

<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <v-offline @detected-condition="setConnected">
  </v-offline>
  <router-view></router-view>
</template>

<script setup>
import service from './serviceBDLocal/indexBD';
import _apis from './serviceBDLocal/apis';
import $router from './router';
import { mdiExportVariant, mdiClose } from '@mdi/js';
import { onMounted, inject, ref } from 'vue';
const swal = inject('$swal');
const setConnected = (e) => {
  service.setLocalstorage(e);
};
onMounted(() => {

  window.addEventListener("message", (e) => {
    if (e && e.data && e.data == "SW_UPDATED") {
      window.caches.keys()
        .then(cache => {
          if (cache) {
            cache.forEach(name => {
              window.caches.delete(name);
            })
          }
        }).finally(() => {
          swal({
            icon: 'info',
            text: 'Por favor refresque la aplicación',
            title: "Nueva versión",
            confirmButtonText: "Actualizar"
          })
            .then((result) => {
              console.log("Se refresco la vista ");
              window.location.reload();
            })
        })
    }
  });
  //   window.addEventListener("online", () => {
  //     console.log("online")

  //   })
  //   window.addEventListener("offline", () => {
  //     console.log("offline")
  //   })
});
// onBeforeUnmount(() => {
//   window.removeEventListener("online", () => {
//     console.log("Event delete")

//   })
//   window.removeEventListener("offline", () => {
//     console.log("offline")
//   })
// })
service.getDb()
  .then(async (db) => {
    const users = await service.getUsers(db);
    if (users && users.length > 0) {
      if ($router.currentRoute._value.path.indexOf('login') >= 0) {
        $router.push("/controlaccess")
      }
    } else {
      $router.push("/login")
    }
  });
</script>

<script >
import { VOffline } from 'v-offline';
import SvgIcon from "vue3-icon";
export default {
  name: 'App',
  components: {
    VOffline,
    SvgIcon
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  /* margin: 10px; */
  padding: 0;
  overflow-x: hidden;
}

.messageInstallApp {
  position: fixed;
  background: #ededed99;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  z-index: 1000;
}

.card-view-APP {
  position: absolute;
  bottom: 0px;
  left: 20px;
  right: 20px;
  background: #fff;
  padding: 20px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}








  
.videoClasss {
    clear: both;
    display: block;
    transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
  }


.videoView {
  position: relative;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
}
  

  
  .videoView p {
    position: absolute;
    padding-bottom: 5px;
    padding-top: 5px;
    background-color: #007f8b;
    color: #fff;
    border: 1px dashed rgba(255, 255, 255, 0.7);
    z-index: 2;
    font-size: 12px;
    margin: 0;
    
  }
  
  .highlighter {
    background: rgba(0, 255, 0, 0.25);
    border: 1px dashed #fff;
    z-index: 1;
    position: absolute;
  }

  .highlighter-confidence {
    border-color: #ff9800; /* Color naranja para problemas de confianza */
}

.highlighter-proximity {
    border-color: #2196F3; /* Color azul para problemas de proximidad */
}

.info {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 3px;
  padding: 3px 6px;
  font-size: 14px;
  z-index: 2;
}

.info-confidence {
  background-color: rgba(255, 152, 0, 0.8); /* Naranja para confianza */
}

.info-proximity {
  background-color: rgba(33, 150, 243, 0.8); /* Azul para proximidad */
}

  
.proximity-info {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 3px;
  padding: 3px 6px;
  font-size: 14px;
  z-index: 2;
}


  .detectOnClick {
    z-index: 0;
  }
  
  .detectOnClick img {
    width: 100%;
  }
  .key-point {
    position: absolute;
    z-index: 1;
    width: 3px;
    height: 3px;
    background-color: #ff0000;
    /* border: 1px solid #ffffff; */
    border-radius: 50%;
    display: block;
  }

  .result-success .processing-info {
    border-left-color: #28a745;
}

.result-fail .processing-info {
    border-left-color: #dc3545;
}

.similarity-result {
    margin: 15px 0;
    padding: 15px;
    background-color: #f0f8ff;
    border-radius: 5px;
    border-left: 4px solid #007bff;
    text-align: center;
}

.similarity-bar {
    height: 20px;
    background-color: #e9ecef;
    border-radius: 10px;
    margin: 10px 0;
    overflow: hidden;
}

.similarity-fill {
    height: 100%;
    background-color: #28a745;
    border-radius: 10px;
    transition: width 0.5s ease-in-out;
}

     
.fade-out {
      animation: fade-out 0.5s forwards;
    }
    

.smile-hint {
      background-color: rgba(255, 255, 255, 0.95);
      color:  #333333;
      padding: 15px 30px;
      border-radius: 25px;
      margin: 10px auto;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
      font-size: 28px;
      text-align: center;
      align-self: center;
      animation: pulse-hint 2s infinite;
      border: 2px solid #0099cc; /* Color azul del logo */
    }
    @keyframes pulse-hint {
      0% { transform: scale(1); }
      50% { transform: scale(1.1); }
      100% { transform: scale(1); }
    }

    
    .message-bubbles {
      position: absolute;
      bottom: 80px;
      left: 20px;
      right: 20px;
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      pointer-events: none;
    }
    
    .message-bubble {
      background-color: rgba(255, 255, 255, 0.9);
      color:  #333333;
      padding: 12px 20px;
      border-radius: 20px;
      margin-bottom: 10px;
      max-width: 80%;
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
      transform-origin: left center;
      animation: pop-in 0.5s forwards;
      font-weight: 500;
      opacity: 0;
      position: relative;
    }
    
    .message-bubble.system {
      background-color: rgba(0, 153, 204, 0.9);
      color: white;
      align-self: flex-end;
      transform-origin: right center;
      border-bottom-right-radius: 5px;
    }
    
    .message-bubble.user {
      border-bottom-left-radius: 5px;
    }
    
    @keyframes pop-in {
      0% { transform: scale(0.8); opacity: 0; }
      50% { transform: scale(1.1); opacity: 1; }
      100% { transform: scale(1); opacity: 1; }
    }


    .smile-emoji {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0);
      font-size: 150px; /* Aumentado de 120px a 150px */
      z-index: 20;
      transition: transform 0.3s ease;
      filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.7));
    }
    
    .smile-emoji.show {
      transform: translate(-50%, -50%) scale(1);
      animation: pulse 1s infinite alternate;
    }
</style>
